import React, { useState } from 'react';
import { TvIcon, MegaphoneIcon, CheckIcon } from '@heroicons/react/24/outline';
import RevenueCalculator from '../calculators/RevenueCalculator';
import ROICalculator from '../calculators/ROICalculator';

const BenefitsShowcase = () => {
  const screenOwnerBenefits = [
    "100% Passive Income",
    "Zero Setup Costs",
    "Full Content Control",
    "Monthly Guaranteed Payments"
  ];

  const advertiserBenefits = [
    "Hyper-Targeted Audiences",
    "Real-Time Analytics",
    "Flexible Campaign Scheduling",
    "3x Better ROI vs Traditional"
  ];

  return (
    <section id="bnfts"className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6">
            Benefits For Everyone
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Screen Owner Benefits */}
          <div className="bg-gradient-to-br from-primary/5 to-transparent rounded-2xl p-8">
            <div className="flex items-center mb-6">
              <TvIcon className="w-8 h-8 text-primary mr-3" />
              <h3 className="text-2xl font-bold text-text-primary">For Screen Owners</h3>
            </div>
            
            <RevenueCalculator />

            <div className="space-y-4">
              {screenOwnerBenefits.map((benefit, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <CheckIcon className="w-5 h-5 text-success" />
                  <span className="text-text-secondary">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Advertiser Benefits */}
          <div className="bg-gradient-to-br from-accent/5 to-transparent rounded-2xl p-8">
            <div className="flex items-center mb-6">
              <MegaphoneIcon className="w-8 h-8 text-accent mr-3" />
              <h3 className="text-2xl font-bold text-text-primary">For Advertisers</h3>
            </div>
            
            <ROICalculator />

            <div className="space-y-4">
              {advertiserBenefits.map((benefit, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <CheckIcon className="w-5 h-5 text-success" />
                  <span className="text-text-secondary">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsShowcase;